import { ISkeletonProps } from './types'
import clsx from 'clsx'
import styles from './styles.module.scss'
import { CustomCSSProperties } from 'src/types'

const Skeleton = ({
  className,
  id,
  size = 'md',
  style,
  type = 'text',
  borderRadius = true,
  hasAnimation = true,
  animationDuration = 1500,
  asType: Component = 'div',
}: ISkeletonProps) => {
  const containerClasses = clsx(
    'mui-skeleton',
    styles.skeleton,
    styles[type],
    styles[size],
    {
      [styles.hasCustomSize]: typeof size === 'number',
    },
    className,
  )

  const holderClasses = clsx(styles[type + 'Holder'], styles[size])

  const itemClasses = clsx(styles.skeletonItem, styles[size], {
    [styles.hasBorderRadius]: borderRadius === true,
    [styles.hasAnimation]: hasAnimation,
    [styles.hasCustomSize]: typeof size === 'number',
    [styles.hasCustomBorderRadius]: typeof borderRadius === 'number',
  })

  const containerStyles = {
    '--customSize': typeof size === 'number' ? size : 0,
    '--animationDuration': `${animationDuration}ms`,
    ...style,
  } as CustomCSSProperties

  const itemStyles = {
    '--customBorderRadius': typeof borderRadius === 'number' ? borderRadius : 0,
    '--customSize': typeof size === 'number' ? size : 0,
  } as CustomCSSProperties

  return (
    <Component
      className={containerClasses}
      data-testid="mui-skeleton"
      id={id}
      style={containerStyles}
    >
      <Component className={holderClasses}>
        <Component className={itemClasses} style={itemStyles}></Component>
      </Component>
    </Component>
  )
}

export default Skeleton
